<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Cadastro de CNAEs</h1>
            <p class="welcome-message">
              <button mat-icon-button routerLink="/configuracoes/servicos">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Visualize e gerencie os CNAEs usados na emissão das notas fiscais de serviço.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button
          mat-stroked-button
          class="btn-secondary btn-spinner"
          [class.btn-loading]="isExcluindoSelecionados"
          [disabled]="isExcluindoSelecionados"
          [matMenuTriggerFor]="opcoesMenu">
          @if (selection.hasValue()) {
            <span>Ações ({{ selection.selected.length }})</span>
          } @else {
            <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          @if (isExcluindoSelecionados) {
            <mat-spinner diameter="20"></mat-spinner>
          }
        </button>
        <mat-menu #opcoesMenu="matMenu">
          <span
            matTooltip="Selecione ao menos um CNAE para excluir"
            [matTooltipDisabled]="selection.hasValue()">
            <button mat-menu-item (click)="abrirModalExcluir()" [disabled]="!selection.hasValue()">
              <mat-icon class="material-symbols-outlined">delete</mat-icon>
              <span>Excluir selecionados</span>
            </button>
          </span>
        </mat-menu>
        <button
          type="button"
          mat-flat-button
          class="btn-primary"
          routerLink="/configuracoes/servicos/cnaes/cadastrar">
          <mat-icon class="material-symbols-outlined">add</mat-icon> Novo CNAE
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input
              matInput
              type="text"
              formControlName="pesquisa"
              placeholder="Busque pelo código ou descrição do CNAE..." />
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    </form>

    @if (_isLoading && _dataSource.data.length === 0) {
      <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (_dataSource.data.length > 0) {
      <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="w-checkbox">
            <mat-checkbox
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="w-checkbox">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="codigo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-codigo text-nowrap">Código</th>
          <td mat-cell *matCellDef="let element" class="w-codigo text-nowrap">{{ element.codigo | mask: masks.cnae }}</td>
        </ng-container>
        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
          <td mat-cell *matCellDef="let element">{{ element.descricao }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
          <td mat-cell *matCellDef="let element" class="text-center w-actions">
            <button
              mat-icon-button
              type="button"
              class="btn-spinner"
              [class.btn-loading]="idCnaeExcluindo === element.idCnae"
              [disabled]="idCnaeExcluindo === element.idCnae"
              [attr.aria-label]="idCnaeExcluindo === element.idCnae ? 'Excluindo CNAE' : 'Ações do CNAE'"
              [matMenuTriggerFor]="menu">
              <span class="material-symbols-outlined">more_horiz</span>
              @if (idCnaeExcluindo === element.idCnae) {
                <mat-spinner diameter="20"></mat-spinner>
              }
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                [routerLink]="['/configuracoes/servicos/cnaes/cadastrar', { idCnae: element.idCnae }]">
                <span class="material-symbols-outlined">edit</span><span>Editar</span>
              </button>
              <button mat-menu-item (click)="abrirModalExcluir(element)">
                <span class="material-symbols-outlined">delete</span><span>Excluir</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div class="mobile-view">
        @for (item of _dataSource.data; track item.idCnae) {
          <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <mat-checkbox
                  (change)="$event ? selection.toggle(item) : null"
                  [checked]="selection.isSelected(item)"
                  color="primary"></mat-checkbox>
                <span class="text-bold">{{ item.codigo | mask: masks.cnae }}</span>
              </div>
              <button
                mat-icon-button
                type="button"
                class="btn-spinner"
                [class.btn-loading]="idCnaeExcluindo === item.idCnae"
                [disabled]="idCnaeExcluindo === item.idCnae"
                [attr.aria-label]="idCnaeExcluindo === item.idCnae ? 'Excluindo CNAE' : 'Ações do CNAE'"
                [matMenuTriggerFor]="menuMobile">
                <span class="material-symbols-outlined">more_horiz</span>
                @if (idCnaeExcluindo === item.idCnae) {
                  <mat-spinner diameter="20"></mat-spinner>
                }
              </button>
              <mat-menu #menuMobile="matMenu">
                <button
                  mat-menu-item
                  [routerLink]="['/configuracoes/servicos/cnaes/cadastrar', { idCnae: item.idCnae }]">
                  Editar
                </button>
                <button mat-menu-item (click)="abrirModalExcluir(item)">Excluir</button>
              </mat-menu>
            </div>
            <div class="card-body-mobile p-3">{{ item.descricao }}</div>
          </div>
        }
      </div>

      <div class="col-12 text-center mt-4 mb-5">
        <button
          mat-button
          class="btn-ver-mais btn-spinner"
          [class.btn-loading]="_isLoading"
          [disabled]="_isLoading || _dataSource.data.length >= _totalRegistros"
          (click)="proximaPagina()">
          <span class="material-symbols-outlined">expand_more</span> Ver Mais
          @if (_isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          }
        </button>
      </div>
    } @else {
      <app-empty-list
        [title]="'Nenhum CNAE encontrado'"
        [subTitle]="'Adicione um novo CNAE para começar'"></app-empty-list>
    }
  </div>
</div>
